<div *ngIf="!init" style="align-self: center;">
  <mat-spinner
    style="margin: auto;"
    color="primary"
    diameter="24"
  ></mat-spinner>
</div>
<div *ngIf="init" class="placer-project-container">
  <div class="button-container">
    <div class="action-buttons">
      <div class="placement-button">
        <button
          class="start-timer action-button clickable placement-button-height"
          [disabled]="taskStarted || disallowStartTask"
          [ngClass]="
            taskStarted || disallowStartTask ? 'start-timer-disabled' : ''
          "
          (click)="startTask()"
        >
          Start taak
        </button>
      </div>
    </div>
  </div>

  <div class="banner project-type-banner taak">
    <div class="banner-text center-text">Taak</div>
  </div>

  <p *ngIf="timeBudget?.length > 0" class="strong center-text">
    Voorziene timing: {{ timeBudget }}
  </p>

  <div class="info-banner taak">
    <div class="project-type-banner banner-text info-banner-text">
      Taak info
    </div>
  </div>

  <div *ngIf="task.title?.length > 0">
    <span class="strong">Titel: </span>
    <span>{{ task.title }}</span>
  </div>

  <ng-container *ngIf="task.description?.length > 0">
    <div class="title upper-space">
      Omschrijving:
    </div>

    <div>
      <span class="preserve-line-break">{{ task.description }}</span>
    </div>
  </ng-container>

  <div
    class="completable-task-executed-button-whitespace horizontal-center-wrapper"
  >
    <div class="horizontal-center-content">
      <div
        *ngIf="displayExecutionTime && executionTimeString?.length > 0"
        class="horizontal-center bottom-space"
      >
        <span class="strong">{{ executionTimeString }}</span>
      </div>
      <div class="d-flex">
        <ng-container *ngIf="submitInProgress || submitQueued">
          <div class="d-flex retry-submit-margin">
            <button
              *ngIf="submitQueued && !submitInProgress"
              mat-button
              class="button executed-button"
              [disabled]="submitting"
              (click)="retrySubmit()"
            >
              Manueel opnieuw proberen
            </button>
            <div
              *ngIf="submitQueued && !submitInProgress"
              matTooltip="Taak staat klaar om ingediend te worden"
            >
              <mat-icon class="queue-icon">cloud_queue</mat-icon>
            </div>
            <div *ngIf="submitInProgress" matTooltip="Taak wordt ingediend">
              <mat-spinner
                class="submitting-icon"
                color="primary"
                diameter="30"
              ></mat-spinner>
            </div>
          </div>
        </ng-container>
        <button
          class="completable-task-executed-button"
          [disabled]="
            !taskStarted || storingOfflineChange || submitting || task.complete
          "
          [ngClass]="
            !taskStarted || storingOfflineChange || submitting || task.complete
              ? 'button-disabled'
              : ''
          "
          (click)="submit()"
        >
          Uitgevoerd
        </button>
      </div>
    </div>
  </div>
</div>
